import companyService from '../../services/companyServices/service'
export default {
    async fetchCompany() {
        try {
            const data = await companyService.fetchCompany();
            return data;
        } catch (error) {
            console.error('Error fetching companies:', error);
            throw error;
        }
    }
}